import { useQuery } from '@tanstack/react-query'
import { registerDeviceApi, getDeviceInfo } from '../api/deviceRegistrationApi'
import { useSelector } from 'react-redux'

const SESSION_STORAGE_KEY = 'device_registered_session'
const LOCAL_STORAGE_KEY = 'device_registered'
const QUERY_KEY = 'DEVICE_REGISTRATION'

export const useDeviceRegistration = (options = {}) => {
  const fcmToken = useSelector((state) => state.auth?.fcmToken) || localStorage.getItem('fcmToken')
  const isRegisteredFlag = typeof window !== 'undefined' && localStorage.getItem(LOCAL_STORAGE_KEY) === 'true'
  const hasDeviceId = typeof window !== 'undefined' && !!localStorage.getItem('deviceId')

  // The device is considered registered if the flag is set OR if we already have a persistent device ID in cache
  const isRegistered = isRegisteredFlag || hasDeviceId

  return useQuery({
    queryKey: [QUERY_KEY, fcmToken],
    queryFn: async () => {
      // Final check inside query function to avoid race conditions
      const currentFlag = localStorage.getItem(LOCAL_STORAGE_KEY) === 'true'
      const currentId = localStorage.getItem('deviceId')

      if (currentFlag || currentId) {
        return { success: true, registered: true, device_id: currentId }
      }

      const deviceInfo = await getDeviceInfo()

      const finalPushToken = fcmToken === 'FAILED' ? '' : (fcmToken || '')

      const response = await registerDeviceApi({
        ...deviceInfo,
        push_token: finalPushToken
      })

      if (typeof window !== 'undefined' && response) {
        localStorage.setItem(LOCAL_STORAGE_KEY, 'true')
        // registerDeviceApi already handles setting the deviceId in localStorage
      }

      return response
    },
    enabled: typeof window !== 'undefined' && !isRegistered && !!fcmToken,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchOnMount: false,
    retry: 0,
    placeholderData: { success: false, registered: false, device_id: 'Loading...' },
    ...options
  })
}
